export class VinRequest {
	
	vin: string;
}